const getNumbersAndTotals = (data, valueKeys = [], singleValueKey = true) => {
    console.log(data, valueKeys);

    // Create a deep copy of the data to avoid modifying the original array
    const numberData = data.map((row) => {
        const newRow = { ...row };  // Shallow copy the row object

        valueKeys.forEach((valueKeyObject) => {
            const key = valueKeyObject?.responseKey;

            // Safely convert the value at the key to a number in the newRow
            newRow[key] = Number(row[key]);
        });

        return newRow;  // Return the updated copy of the row
    });

    // Calculate totals for each key in valueKeys
    let totals = valueKeys.reduce((acc, valueKeyObject) => {
        const key = valueKeyObject?.responseKey;
        acc[key] = numberData.reduce((sum, row) => sum + (row[key] || 0), 0);
        return acc;
    }, {});
    console.log(numberData, totals);

    if (singleValueKey) {

        const total = totals[valueKeys[0]?.responseKey] || 0
        console.log(total);





        return { numberData, total };

    }

    return { numberData, totals };
};

export { getNumbersAndTotals };
